import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';

import DateTime from '../../DateTime';

import { thumbnailPlaceholder } from '../../../helpers/Files';

const AdminFTPQueueListItem = ({ file }) => {
  const fileUser = (file.file && file.file.user) ?
    file.file.user :
    (file.account.user || file.account.created_by);

  const fileTo = {
    pathname: `/files/${file.file ? file.file.uuid : ''}`,
    state: {
      modal: true,
      fromFTPQueue: true,
    },
  };

  const statusIcon = () => {
    let icon = '';
    switch (file.status) {
      case 'failed':
        icon = 'fa-xmark';
        break;
      case 'pending':
        icon = 'fa-timer';
        break;
      case 'in_progress':
        icon = 'fa-cloud-arrow-up';
        break;
      case 'complete':
        icon = 'fa-check';
        break;
      default:
        icon = 'fa-timer';
    }

    return (
      <>
        <i id={`file-status-${file.id}`} className={`far ${icon} status-${file.status}`} />
        <UncontrolledTooltip placement="top" target={`file-status-${file.id}`}>
          {file.status_name}
        </UncontrolledTooltip>
      </>
    );
  };

  return (
    <tr className={classnames({ 'file-error': file.status === 'failed' })}>
      <td className="file-image">
        {file.file ? (
          <Link to={fileTo} className="list-item-img-wrapper">
            <img
              id={`file-img-${file.file.uuid}`}
              className="list-item-img"
              width="100%"
              src={file.file.urls.thumbnail}
              srcSet={`${file.file.urls.thumbnail} 1x, ${file.file.urls.thumbnailx2} 2x`}
              alt={file.file.display_name}
            />
          </Link>
        ) : (
          <div className="list-item-img-wrapper">
            <img
              id={`file-img-${file.id}`}
              className="list-item-img"
              width="100%"
              src={thumbnailPlaceholder}
              alt={file.file_name}
            />
          </div>
        )}
      </td>
      <th scope="row">
        {file.filename}
      </th>
      <td>
        {file.account.login}@{file.account.login_suffix}
        <span className="file-user">
          {fileUser.name}
        </span>
      </td>
      <td>
        <DateTime
          id={`file-created-${file.uuid}`}
          dateTime={file.created_at}
        />
      </td>
      <td>
        {statusIcon()}
      </td>
    </tr>
  );
};

AdminFTPQueueListItem.propTypes = {
  file: PropTypes.object.isRequired,
};

export default AdminFTPQueueListItem;
